import { useMutation } from "react-query";
import { API_LOGOUT } from "consts";
import { useHttpClient } from "contexts/httpClient";

export default function useLogout(config) {
  const httpClient = useHttpClient();
  return useMutation(() => httpClient.get(API_LOGOUT), config);
}
